
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LeftBackdrop from "./LeftBackdrop";
import PhoneForm from "./PhoneForm";
import "./styling/LandingPage.css";
import Header  from "./Header";
import Footer from "./Footer";
import fetchUserDetails from "./apis/fetchUserDetails";

const LandingPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handlePhoneSubmit = ({ phone, dob, course }) => {
    setLoading(true);
    console.log(phone, dob, course);

    //+++++++++++++++++++++++++++++++++++++++++++++
    fetchUserDetails(phone, dob, course).then((res) => {
      if (res && res.status === 200 && res.data) {
       console.log(res.data);
       const user = res.data;
       const username = encodeURIComponent(user.name);
       navigate(`/certificate/${username}`, { state: { user } });
      } else {
        alert("Please enter correct credentials");
      }
    }).catch((err) => {
      console.log(err);
      alert("Error occurred while fetching user data.");
    });

    setLoading(false);
  };

  return (
    <div className="app-container">
      <Header />
      <div className="split-screen">
        <div className="left-section">
          <LeftBackdrop />
        </div>
        <div className="right-section">
          <PhoneForm onSubmit={handlePhoneSubmit} loading={loading} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;